import React from "react";
import Search from "../search/search";

const Hero = () => {
  return (
    <section className="hero-sec-six">
      <div className="container">
        <div className="hero-content">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div
                className="banner-content wow fadeInUp mb-4"
                data-wow-delay="0.3"
              >
                <h1 className="text-white display-5 mb-2">
                  Đặt tour du lịch có thể là một cách thú vị để khám phá một
                  điểm đến mới!
                </h1>
                <p className="text-white">
                  Điểm đến cuối cùng của bạn cho mọi thứ giúp bạn ăn mừng và ghi
                  nhớ trải nghiệm du lịch.
                </p>
              </div>
              <div className="banner-form-tab-six">
                <ul className="nav">
                  <li>
                    <a
                      href="#"
                      className="nav-link active"
                      data-bs-toggle="tab"
                      data-bs-target="#Tour"
                    >
                      <i className="fa-solid fa-camera me-2"></i>Tour
                    </a>
                  </li>
                </ul>
              </div>

              <Search />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
